<app-tab001 *ngIf="slug === '001'"></app-tab001>
